module.exports = __webpack_public_path__ + "static/media/wizards-new-grey.34ece2de.svg";